import { z } from 'zod';
import { useGetLocationId, useGetMemberId } from '.';
import { useNavigate } from 'react-router-dom';
import { getRoutePath } from '~/router/routes';
import { toast } from 'sonner';

const schema = z.object({
  locationId: z.number().min(0).catch(0),
  memberId: z.number().min(0).catch(0),
  isDea: z.boolean(),
});

type idsShape = z.infer<typeof schema>;

export function useGetIds() {
  const navigate = useNavigate();

  const { locationId, isDea } = useGetLocationId();
  const { memberId } = useGetMemberId();
  const result: idsShape = { locationId: 0, memberId: 0, isDea: false };

  try {
    result.locationId = locationId;
    result.memberId = memberId;
    result.isDea = isDea;
    schema.parse(result);
  } catch (e) {
    console.error({ e });
    toast.error('Error in location and/or member validation');
    navigate(getRoutePath('auth.login'));
  }
  return result;
}
